import { render, staticRenderFns } from "./ContratoRegistra.vue?vue&type=template&id=6ec0bd1e&"
import script from "./ContratoRegistra.vue?vue&type=script&lang=js&"
export * from "./ContratoRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports